
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/maxio",
      function () {
        return require("private-next-pages/destinations/maxio.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/maxio"])
      });
    }
  